import { ScrollTrigger } from 'gsap/ScrollTrigger';

/** Ripristina lo scroll della finestra (html + body). */
export function scrollToTop() {
  if (typeof window === 'undefined') return;
  const html = document.documentElement;
  const body = document.body;
  const prevHtml = html.style.scrollBehavior;
  const prevBody = body.style.scrollBehavior;
  html.style.scrollBehavior = 'auto';
  body.style.scrollBehavior = 'auto';
  window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  html.scrollTop = 0;
  body.scrollTop = 0;
  html.style.scrollBehavior = prevHtml;
  body.style.scrollBehavior = prevBody;
}

/** Da chiamare a ogni cambio route SPA — evita che GSAP/browser riapplichino vecchie posizioni. */
export function resetScrollForRouteChange() {
  scrollToTop();
  ScrollTrigger.getAll().forEach((st) => st.kill());
  if (typeof ScrollTrigger.clearScrollMemory === 'function') {
    ScrollTrigger.clearScrollMemory();
  }
}
